export const discountAgreementActionTypes = {
    STORE_DISCOUNT_AGREEMENTS: "STORE_DISCOUNT_AGREEMENTS",
    STORE_GROUPED_DISCOUNT_AGREEMENTS: "STORE_GROUPED_DISCOUNT_AGREEMENTS",
    STORE_DISCOUNT_AGREEMENT: "STORE_DISCOUNT_AGREEMENT",
    STORE_DISCOUNT_AGREEMENT_VERSIONS: "STORE_DISCOUNT_AGREEMENT_VERSIONS",
    STORE_CHARGE_PLAN_DISCOUNTS: "STORE_CHARGE_PLAN_DISCOUNTS",
}